"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleController = void 0;
const utils_1 = require("@/utils");
/**
 * 켜고 끄는 상태를 다루는 규칙. 값을 바꾸면 계열 공통 모양의 change로 알리고, disabled면 바꾸지도 알리지도 않는다.
 * 계열마다 상태를 담는 프로퍼티 이름이 다르므로(checked·pressed) 그 이름만 받고, change detail도 그 이름을 key로 쓴다.
 * value는 부모 그룹이 항목을 가려낼 수 있게 늘 string으로 싣는다.
 * 그 프로퍼티는 호스트의 reactive property라 값을 바꾸면 호스트가 스스로 다시 그리므로, 갱신을 따로 요청하지 않는다.
 */
class ToggleController {
    constructor(host, key) {
        this.host = host;
        this.key = key;
    }
    toggle() {
        this.set(!this.host[this.key]);
    }
    set(value) {
        if (this.host.disabled)
            return;
        this.host[this.key] = value;
        (0, utils_1.emit)(this.host, 'change', { [this.key]: value, value: this.host.value ?? '' });
    }
}
exports.ToggleController = ToggleController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9nZ2xlLWNvbnRyb2xsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0b2dnbGUtY29udHJvbGxlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtQ0FBOEI7QUFJOUI7Ozs7O0dBS0c7QUFDSCxNQUFhLGdCQUFnQjtJQUMzQixZQUFvQixJQUF1QyxFQUFVLEdBQVE7UUFBekQsU0FBSSxHQUFKLElBQUksQ0FBbUM7UUFBVSxRQUFHLEdBQUgsR0FBRyxDQUFLO0lBQUcsQ0FBQztJQUVqRixNQUFNO1FBQ0osSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUE7SUFDaEMsQ0FBQztJQUVELEdBQUcsQ0FBQyxLQUFjO1FBQ2hCLElBQUksSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFRO1lBQUUsT0FDdkI7UUFBQyxJQUFJLENBQUMsSUFBNkIsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLEdBQUcsS0FBSyxDQUFBO1FBQ3RELElBQUEsWUFBSSxFQUFDLElBQUksQ0FBQyxJQUFJLEVBQUUsUUFBUSxFQUFFLEVBQUUsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssSUFBSSxFQUFFLEVBQUUsQ0FBQyxDQUFBO0lBQ2hGLENBQUM7Q0FDRjtBQVpELDRDQVlDIn0=